import ReportSegment from './reportSegment'

export default ReportSegment
